var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('div',{staticClass:"d-flex justify-center fill-height"},[_c('v-icon',_vm._g({staticClass:"white--text"},on),[_vm._v(" "+_vm._s(_vm.currentIcon)+" ")])],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm._f("titleCase")((_vm.status || _vm.$t('unknown')))))])])
}
var staticRenderFns = []

export { render, staticRenderFns }